<template>
    <div class="page-content g9">
        <Accord title="Materials">

            <Accord title="Supply amounts">
                <Tabs :menu="['Total DUN', 'Total Primary Packaging']">
                    <div class="tab">
                        <LineChart chart-name="aggregationSupplyTotalDun" :settings="supplyTotalDunSettings" :isAggregation="true"></LineChart>
                    </div>
                    <div class="tab">
                        <LineChart chart-name="aggregationSupplyPackaging" :settings="supplyPackagingSettings" :isAggregation="true"></LineChart>
                    </div>
                </Tabs>
            </Accord>

            <Accord title="Ancillary amount">
                <LineChart chart-name="aggregationAncillaryAmount" :settings="ancillaryAmountSettings" :isAggregation="true"></LineChart>
            </Accord>
            
            <Accord title="Packaging Campaigns">
                <LineChart chart-name="aggregationPackagingCampaigns" :settings="packagingCampaignsSettings" :isAggregation="true" :is-gantt="true"></LineChart>
                <button class="right" v-on:click="onDownloadProductionPlanClick">Download packaging plan</button>
            </Accord>
        
            <Accord title="Stock Level">
                <Tabs :menu="['Site', 'Depot']">
                    <div class="tab">
                        <LineChart chart-name="aggregationStockSite" :settings="stockSettings"  :isAggregation="true"></LineChart>
                    </div>
                    <div class="tab">
                        <LineChart chart-name="aggregationStockDepot" :settings="stockSettings" :isAggregation="true"></LineChart>
                    </div>                   
                </Tabs>
            </Accord>

            <Accord title="Cost">
                <Tabs :menu="['DUN', 'API', 'Ancillary']">
                    <div class="tab">
                        <LineChart chart-name="aggregationCostDun" :settings="costSettings" :isAggregation="true"></LineChart>
                    </div>
                    <div class="tab">
                        <LineChart chart-name="aggregationCostApi" :settings="costSettings" :isAggregation="true"></LineChart>
                    </div>
                    <div class="tab">
                        <LineChart chart-name="aggregationCostAncillary" :settings="costSettings" :isAggregation="true"></LineChart>
                    </div>
                </Tabs>
            </Accord>

        </Accord>
    </div>
</template>

<script>
    import Accord from "../../Accord.vue"
    import LineChart from "../Charts/LineChart.vue"
    import Tabs from "../../Tabs.vue"

    export default {
        components: {
            Accord,
            LineChart,
            Tabs
        },
        methods: {
            supplyTotalDunSettings (data) {
                let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
                chart.chart = {
                    type: "column"
                };
                chart.legend.reversed = true;
                chart.series = data.series;
                chart.xAxis.categories =  data.categories;
                chart.yAxis.title.text = "DUN";

                chart.tooltip = {
                    useHTML: true,
                    headerFormat: '<span style="color: {series.color}">{series.name} </span><table>',
                    pointFormatter: function () {
                        return this.series.name === 'Packaging'
                            ? '<tr><td>Total</td><td style="text-align: right"><b>' + this.real.toLocaleString() + '</b></td></tr>'
                            : '<tr><td>Total</td><td style="text-align: right"><b>' + this.real.toLocaleString() + '</b></td></tr>' +
                              '<tr><td>Surplus</td><td style="text-align: right"><b>' + this.percentage.toLocaleString() + ' %</b></td></tr>';
                    },
                    footerFormat: '</table>',
                };

                return  chart;
            },
            onDownloadProductionPlanClick() {
                window.open("/api/dataviewaggregation/DownloadProductionPlan?id=" + this.$route.params.id)
            },
            supplyPackagingSettings(data) {
                let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
                chart.chart = {
                    type: "column"
                };
                chart.legend.reversed = true;
                chart.tooltip = {
                    useHTML: true,
                    headerFormat: '<span style="color: {series.color}">{series.name} </span><table>',
					pointFormatter: function () {
						return this.series.name === "Exact"
							? '<tr><td>Primary Package total</td><td style="text-align: right"><b>' + this.packageTotal.toLocaleString() + '</b></td></tr>' +
							  '<tr><td>Dosage form total</td><td style="text-align: right"><b>' + this.formTotal.toLocaleString() + ' ' + this.formUnit + '</b></td></tr>' +
                              '<tr><td>API total</td><td style="text-align: right"><b>' + this.api.toLocaleString() + ' ' + this.apiUnit + '</b></td></tr>' +
							  '<tr><td>Surplus</td><td style="text-align: right"><b>' + this.percentage.toLocaleString() + '</b></td></tr>'
							:'<tr><td>Primary Package total</td><td style="text-align: right"><b>' + this.packageTotal.toLocaleString() + '</b></td></tr>' +
							  '<tr><td>Dosage form total</td><td style="text-align: right"><b>' + this.formTotal.toLocaleString() + ' ' + this.formUnit + '</b></td></tr>' +
							  '<tr><td>API total</td><td style="text-align: right"><b>' + this.api.toLocaleString() + ' ' + this.apiUnit + '</b></td></tr>' +
							  '<tr><td>Surplus</td><td style="text-align: right"><b>' + this.percentage.toLocaleString() + ' %</b></td></tr>';
					},
                    footerFormat: '</table>',
                    valueDecimals: 2
                };

                chart.series = data.series;
                chart.xAxis.categories =  data.categories;
                chart.yAxis.title.text = "Primary Packaging";

                return chart;
            },
            ancillaryAmountSettings (data) {
                let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
                chart.chart = {
                    type: "column"
                };
                chart.legend.reversed = true;
                chart.series = data.series;
                chart.xAxis.categories =  data.categories;
                chart.yAxis.title.text = "Unit";
                chart.tooltip = {
                    useHTML: true,
                    headerFormat: '<span style="color: {series.color}">{series.name} </span><table>',
                    pointFormatter: function () {
                        return this.series.name === 'Packaging'
                            ? '<tr><td>Total</td><td style="text-align: right"><b>' + this.y + '</b></td></tr>'
                            : '<tr><td>Total</td><td style="text-align: right"><b>' + this.y + '</b></td></tr>' +
                              '<tr><td>Surplus</td><td style="text-align: right"><b>' + this.percentage.toLocaleString() + ' %</b></td></tr>';
                    },
                    footerFormat: '</table>'
                };

                return  chart;
            },

            packagingCampaignsSettings (data) {
                let chart = {
                    type: "gantt",
                    legend: {
                        align: "left",
                            verticalAlign: "top",
                            borderWidth: 0
                    },
                    title: {
                        text: null
                    },
                    xAxis: {
                        type: "datetime",
                        cropThreshold: Number.MAX_VALUE,
                    },
                    yAxis: {
                        uniqueNames: true,
                        cropThreshold: Number.MAX_VALUE
                    },
                    navigator: {
                        enabled: true,
                        liveRedraw: true,
                        series: {
                            type: "gantt",
                            pointPlacement: 0.5,
                            pointPadding: 0.25
                        },
                        yAxis: {
                            reversed: true,
                            categories: []
                        }
                    },
                    scrollbar: {
                        enabled: true
                    },
                    rangeSelector: {
                        enabled: true,
                        selected: 6, // "All" - if rangeSelector.buttons is changed this should also be changed
                        buttonPosition: {
                            align: "left",
                            x: -50
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    tooltip: {
                        useHTML: true,
                        headerFormat: '<span style="color: {series.color}">{series.name} </span>',
                        pointFormat: '' +
                            'Packaging start date: <b>{point.start:%d-%m-%Y}</b><br>' +
                            'Available / Release date: <b>{point.end:%d-%m-%Y}</b><br>' +
                            'Expiry date: <b>{point.expiry:%d-%m-%Y}</b><br>' +
                            'Batch / Lot size: <b>{point.batchSize:,.f}</b><br>' +
                            'Expired DUN\'s from the batch: <b>{point.expired:,.f}</b><br>' +
                            'Remaining DUN\'s on stock: <b>{point.remaining:,.f}</b><br>' +
                            'Lot/batch type: <b>{point.type}</b><br>' +
                            'Study name: <b>{point.studyName}</b>',
                        footerFormat: '',
                        valueDecimals: 2
                    }
                };

                chart.series = data.series;

                return chart;
            },

            stockSettings(data) {
                let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
                chart.chart = {
                    type: "line",
                    zoomType: "x"
                };
                chart.series = data.series;
                chart.xAxis.type = "datetime";
                chart.yAxis.title.text = "DUN";
                chart.xAxis.title.text = "Date";

                return chart;
            },

            costSettings(data) {
                let chart = this.cloneObject(this.$store.state.dataView.chartDefaults);
                chart.chart = {
                    type: "column"
                };
                chart.legend.reversed = true;
                chart.series = data.series;
                chart.xAxis.categories =  data.categories;
                chart.yAxis.title.text =  this.$store.state.dataView.forecast.currency;
                chart.tooltip = {
                    useHTML: true,
                    headerFormat: '<span style="color: {series.color}">{series.name} </span><table>',
                    pointFormatter: function () {
                        return this.series.name === 'Packaging'
                            ? '<tr><td>Total</td><td style="text-align: right"><b>' + this.y.toLocaleString() + '</b></td></tr>'
                            : '<tr><td>Total</td><td style="text-align: right"><b>' + this.y.toLocaleString() + '</b></td></tr>' +
                              '<tr><td>Surplus</td><td style="text-align: right"><b>' + this.percentage.toLocaleString() + ' %</b></td></tr>';
                    },
                    footerFormat: '</table>',
                };

                return chart;
            },
        }
    }
</script>
